/**
 * @file This file contains methods used for translation purposes
 */
/* @intl-ignore */
import { n__, __, p__, np__, N__ } from 'bits/intl'
import { Component, Vue } from 'vue-property-decorator'
import t from 'vuedirectives/t'

/**
 * Declared same mixin as component to use with Mixins helper function
 * in vue class style components
 */
@Component({
  directives: { t },
  filters: { __: __ },
})
export class IntlMixin extends Vue {
  __(phrase: string, args?: object): string {
    return __(phrase, args)
  }

  n__(singularPhrase: string, pluralPhrase: string, num: number, args: object): string {
    return n__(singularPhrase, pluralPhrase, num, args)
  }

  p__(context: string, phrase: string, args?: object): string {
    return p__(context, phrase, args)
  }

  np__(context: string, singularPhrase: string, pluralPhrase: string, num: number, args: object): string {
    return np__(context, singularPhrase, pluralPhrase, num, args)
  }

  N__(phrase: string): string {
    return N__(phrase)
  }
}

export default {
  directives: { t },
  filters: {
    __: __,
  },
  methods: {
    __: __,
    n__: n__,
    p__: p__,
    np__: np__,
    N__: N__,
  },
}
